/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type WPLOrderMessage = {
    readonly id?: number;
    message_trigger?: WPLOrderMessage.message_trigger | null;
    status?: WPLOrderMessage.status;
    /**
     * Optional reason for error status
     */
    error_reason?: string | null;
    readonly created_at?: string;
}

export namespace WPLOrderMessage {

    export enum message_trigger {
        A = 'A',
        G = 'G',
        I = 'I',
        S = 'S',
        P = 'P',
    }

    export enum status {
        PENDING = 'pending',
        SUCCESS = 'success',
        ERROR = 'error',
        HOLD = 'hold',
        DROPPED = 'dropped',
    }


}
